

import ListJobFamAndRoleTable from "../../components/Forms/ListJobFamAndRoleTable";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";






function ListJobFamAndRole() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <ListJobFamAndRoleTable/>
            
            </BasicCard>
        </>
    )
}
export default ListJobFamAndRole;